import { render, staticRenderFns } from "./PrivacyStatement.vue?vue&type=template&id=7c5b7c2b&scoped=true&"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyStatement.vue?vue&type=style&index=0&id=7c5b7c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b7c2b",
  null
  
)

export default component.exports